import React, {useState, useEffect} from "react";

import '../icons/icons.css'
import '../style.css'
import logo from '../assets/MadnessLogo-.png'
import backgroundImg from '../PwrMad-BG.png'
import { finals, rangers, roundOne, roundThree, roundTwo, semi } from "../data";
import questionMarkGreen from '../assets/avatars/green_placeholder.png'
import questionMarkWhite from '../assets/avatars/white_placeholder.png'
import greenRanger from '../assets/avatars/MMPRGreen.png'
import whiteRanger from '../assets/avatars/MMPRWhite.png'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Link,IconButton } from "@mui/material";
import bolt from '../assets/PwrLogo.png'
import { Container } from "react-bootstrap";
import { Twitter } from "@mui/icons-material";
import axios from "axios";
// import TwitterIcon from '@mui/icons-material/Twitter';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'transparent',
 backgroundImage:`url('${backgroundImg}')`,
 border:'none',
  // boxShadow: 24,
  p: 4,
};

function Copyright(props) {
  return (
    <Typography variant="body2" color="white" align="center" {...props}>
      <Link target='_blank' href="https://twitter.com/pwrrngr"><img width={'225px'} src={bolt}/></Link>
      <br />
      {'Copyright © '}
      <Link target='_blank' color="inherit" href="https://pwrrngr.com/">
        PWRRNGR
      </Link>{' '}
     
      {new Date().getFullYear()}  {'.'}
     <Link target='_blank' href="https://twitter.com/pwrrngr"><IconButton ><Twitter htmlColor="white"/></IconButton></Link>
     <br/>
     <Link target='_blank' href="https://twitter.com/MyNameIsShaunnn"><Typography variant="subtitle2" sx={{color:'white'}}>Art By MyNameIsShaunnn on <Twitter htmlColor="white"/></Typography></Link>
     
     <Link target='_blank' href="https://twitter.com/Stormbreakerer"><Typography variant="subtitle2" sx={{color:'white'}}>Character Sheets By TylerMc on <Twitter htmlColor="white"/></Typography></Link>

    </Typography>
  );
}


const HoverListItem = (props)=>{
  const [imgSize,setImgSize] = useState('75px')
  const [z,setZ] = useState('1');
  const [top,setTop] =useState(null);
  const [bottom,setBottom] =useState(null);

  // useEffect(()=>{
  //   let id = props.TweetId;
  //   console.log(props.TweetId)
  //   const fetchData = async ()=>{
      
  //     let localhost = 'http://localhost:3001/'
  //     let api = 'https://twitter-poll-api.herokuapp.com/'
          
  //         let resp =  await axios.post(api + `?id=${id}`)
  //          console.log(resp.data)
  //         setTop(resp.data.top)
  //         setBottom(resp.data.bottom)

       
  //         console.log(roundOne)
          

          
  //   }
  //   if(props.TweetId !== null){
  //     fetchData()
      
  //     }

 
 
   
  
  // },[])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[top])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[bottom])
  const handleImgSizeUp = ()=>{
   setImgSize('275px')
   setZ('1000')

  }

  const handleImgSizeDown = ()=>{
    setImgSize('75px')
    setZ('1')
  }
  return (
    <div>
    <li onClick={props.OnClickTop} style={{opacity:props.OpacityTop}} className="team team-top"><img className="ranger-image-disable" width={imgSize} height="auto" src={props.AvatarTop} /><Typography variant="button" sx={{marginTop:top != null ? '15px':'0px', marginLeft:top != null ? '12px':'0px'}}><b>{top != null ? top.toFixed(2): top}{top != null ? "%": ''}</b></Typography></li>
    <li onClick={props.OnClickBottom} style={{opacity:props.OpacityBottom}} className="team team-bottom" ><img className="ranger-image-disable" width={imgSize} height="auto" src={props.AvatarBottom} /><Typography variant="button" sx={{marginTop:bottom != null ? '15px':'0px', marginLeft:bottom != null ? '12px':'0px'}}><b>{top != null ? bottom.toFixed(2): bottom}{bottom != null ? "%": ''}</b></Typography></li>
    </div>
  )
}

const HoverListItemRd2 = (props)=>{
  const [imgSize,setImgSize] = useState('75px')
  const [z,setZ] = useState('1');
  const [top,setTop] =useState(null);
  const [bottom,setBottom] =useState(null);

  // useEffect(()=>{
  //   let id = props.TweetId;
  //   console.log(props.TweetId)
  //   const fetchData = async ()=>{
      
  //     let localhost = 'http://localhost:3001/'
  //     let api = 'https://twitter-poll-api.herokuapp.com/'
          
  //         let resp =  await axios.post(api + `?id=${id}`)
  //          console.log(resp.data)
  //         setTop(resp.data.top)
  //         setBottom(resp.data.bottom)

       
  //         console.log(roundOne)
          

          
  //   }
  //   if(props.TweetId !== null){
  //     fetchData()
      
  //     }

 
 
   
  
  // },[])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[top])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[bottom])
  const handleImgSizeUp = ()=>{
   setImgSize('275px')
   setZ('1000')

  }

  const handleImgSizeDown = ()=>{
    setImgSize('75px')
    setZ('1')
  }
  return (
    <div>
  
    <ul className="matchup rd2match">
            <li  onClick={props.OnClickTop} id="rd2Match1WName" className={props.ClassTop} style={{justifyContent:'center',opacity:props.OpacityTop}}>
             <img width={imgSize} src={props.AvatarTop} height="auto"/><Typography variant="button" sx={{marginTop:top != null ? '15px':'0px', marginLeft:top != null ? '12px':'0px'}}><b>{top != null ? top.toFixed(2): top}{top != null ? "%": ''}</b></Typography>
            </li>
            <li   onClick={props.OnClickBottom} id="rd2Match2WName" className={props.ClassBottom}  style={{justifyContent:'center',opacity:props.OpacityBottom}}>
             <img width={imgSize} src={props.AvatarBottom}  height="auto"/><Typography variant="button" sx={{marginTop:bottom != null ? '15px':'0px', marginLeft:bottom != null ? '12px':'0px'}}><b>{top != null ? bottom.toFixed(2): bottom}{bottom != null ? "%": ''}</b></Typography>
            </li>
          </ul>
    
    </div>
  )
}


const HoverListItemRd3 = (props)=>{
  const [imgSize,setImgSize] = useState('75px')
  const [z,setZ] = useState('1');
  const [top,setTop] =useState(null);
  const [bottom,setBottom] =useState(null);

  // useEffect(()=>{
  //   let id = props.TweetId;
  //   console.log(props.TweetId)
  //   const fetchData = async ()=>{
      
  //     let localhost = 'http://localhost:3001/'
  //     let api = 'https://twitter-poll-api.herokuapp.com/'
          
  //         let resp =  await axios.post(api + `?id=${id}`)
  //          console.log(resp.data)
  //         setTop(resp.data.top)
  //         setBottom(resp.data.bottom)

       
  //         console.log(roundOne)
          

          
  //   }
  //   if(props.TweetId !== null){
  //     fetchData()
      
  //     }

 
 
   
  
  // },[])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[top])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[bottom])
  const handleImgSizeUp = ()=>{
   setImgSize('275px')
   setZ('1000')

  }

  const handleImgSizeDown = ()=>{
    setImgSize('75px')
    setZ('1')
  }
  return (
    <div>
  
    <ul className={props.ULClass}>
            <li  onClick={props.OnClickTop} id="rd2Match1WName" className={props.ClassTop} style={{justifyContent:'center',opacity:props.OpacityTop}}>
             <img width={imgSize} src={props.AvatarTop} height="auto"/><Typography variant="button" sx={{marginTop:top != null ? '15px':'0px', marginLeft:top != null ? '12px':'0px'}}><b>{top != null ? top.toFixed(2): top}{top != null ? "%": ''}</b></Typography>
            </li>
            <li   onClick={props.OnClickBottom} id="rd2Match2WName" className={props.ClassBottom}  style={{justifyContent:'center',opacity:props.OpacityBottom}}>
             <img width={imgSize} src={props.AvatarBottom}  height="auto"/><Typography variant="button" sx={{marginTop:bottom != null ? '15px':'0px', marginLeft:bottom != null ? '12px':'0px'}}><b>{top != null ? bottom.toFixed(2): bottom}{bottom != null ? "%": ''}</b></Typography>
            </li>
          </ul>
    
    </div>
  )
}


const HoverListItemRdSemi = (props)=>{
  const [imgSize,setImgSize] = useState('75px')
  const [z,setZ] = useState('1');
  const [top,setTop] =useState(null);
  const [bottom,setBottom] =useState(null);

  // useEffect(()=>{
  //   let id = props.TweetId;
  //   console.log(props.TweetId)
  //   const fetchData = async ()=>{
      
  //     let localhost = 'http://localhost:3001/'
  //     let api = 'https://twitter-poll-api.herokuapp.com/'
          
  //         let resp =  await axios.post(api + `?id=${id}`)
  //          console.log(resp.data)
  //         setTop(resp.data.top)
  //         setBottom(resp.data.bottom)

       
  //         console.log(roundOne)
          

          
  //   }
  //   if(props.TweetId !== null){
  //     fetchData()
      
  //     }

 
 
   
  
  // },[])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[top])

  // useEffect(()=>{
  //   if(Number(top) > Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerTop)
  //     console.log(roundOne)
  //   } 
    
  //   if(Number(top) < Number(bottom)){
  //     roundOne[props.Index].winning.push(roundOne[props.Index].rangerBottom)
  //     console.log(roundOne)
  //   }
  // },[bottom])
  // const handleImgSizeUp = ()=>{
  //  setImgSize('275px')
  //  setZ('1000')

  // }

  // const handleImgSizeDown = ()=>{
  //   setImgSize('75px')
  //   setZ('1')
  // }
  return (
    <div>
  
    {/* <ul className={props.ULClass}>
            <li  onClick={props.OnClickTop} id="rd2Match1WName" className={props.ClassTop} style={{justifyContent:'center',opacity:props.OpacityTop}}>
             <img width={imgSize} src={props.AvatarTop} height="auto"/><Typography variant="button" sx={{marginTop:top != null ? '15px':'0px', marginLeft:top != null ? '12px':'0px'}}><b>{top != null ? top.toFixed(2): top}{top != null ? "%": ''}</b></Typography>
            </li>
            <li   onClick={props.OnClickBottom} id="rd2Match2WName" className={props.ClassBottom}  style={{justifyContent:'center',opacity:props.OpacityBottom}}>
             <img width={imgSize} src={props.AvatarBottom}  height="auto"/><Typography variant="button" sx={{marginTop:bottom != null ? '15px':'0px', marginLeft:bottom != null ? '12px':'0px'}}><b>{top != null ? bottom.toFixed(2): bottom}{bottom != null ? "%": ''}</b></Typography>
            </li>
          </ul> */}

           <ul className={props.ULClass} style={{justifyContent:'center'}}>
            <li  onClick={props.OnClickTop} style={{justifyContent:'center',opacity:props.OpacityTop}}  className={props.ClassTop}>
            <img src={props.AvatarTop} height="auto" width="75px"/>
           <Typography variant="button" sx={{marginTop:top != null ? '15px':'0px', marginLeft:top != null ? '12px':'0px'}}><b>{top != null ? top.toFixed(2): top}{top != null ? "%": ''}</b></Typography>
            </li>
            <li onClick={props.OnClickBottom} style={{justifyContent:'center',opacity:props.OpacityBottom}} className={props.ClassBottom}>
            <img src={props.AvatarBottom}  height="auto" width="75px"/>
           <Typography variant="button" sx={{marginTop:bottom != null ? '15px':'0px', marginLeft:bottom != null ? '12px':'0px'}}><b>{top != null ? bottom.toFixed(2): bottom}{bottom != null ? "%": ''}</b></Typography>
            </li>
          </ul>
    
    </div>
  )
}


export const Bracket = ()=>{
  const [showImage, setShowImage] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [rd2match1, setRd2Match1] = useState()
  const[dndLink, setDndLink] = useState('');  
  const handleOpen = (a) => {
 
    setOpen(true);
    setShowImage(a)
  }
  const handleClose = () => setOpen(false);
    return(
        <div style={{fontFamily:'arial'}}>
          <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{backgroundColor:'transparent'}}
      >
         <a target="_blank" href={dndLink}>
        <Box sx={style}>
         <img className="ranger-image-disable" width="100%" src={showImage}/>
        </Box>
        </a>
      </Modal>
            <>
            
  <header style={{backgroundColor:'black'}} className="hero">
  <Row>
        <Col>
        <img className="ranger-image-disable" width="70%" style={{marginTop:'25px'}} height="auto" src={greenRanger}/>
        </Col>
        <Col>    <img style={{marginTop:'20px'}} className="ranger-image-disable" width="100%" height="auto" src={logo} /></Col>
        <Col><img className="ranger-image-disable" width="70%" style={{marginTop:'25px'}} height="auto" src={whiteRanger}/></Col>
      </Row>

    
    <div>

    </div>
 
   
  </header>
  <section id="bracket">
    
    <div className="containerx">
      <div className="split split-one">
        <div
          id="divtoshow"
          style={{
            height: 150,
            width: 100,
            backgroundColor: "blueviolet",
            zIndex: 100,
            position: "fixed",
            display: "none"
          }}
        >
         
        </div>
        <div className="round round-one current">
          <div className="round-details">
            Round 1<br />
            <span className="date">March 6</span>
          </div>
          <ul id="matchup1" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[0].rangerTop.characterCard); setDndLink(roundOne[0].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[0].rangerBottom.characterCard); setDndLink(roundOne[0].rangerBottom.ddLink)}}
          AvatarTop={roundOne[0].rangerTop.avatar}
          AvatarBottom={roundOne[0].rangerBottom.avatar}
          TweetId={roundOne[0].tweetId}
          Index={0}
          OpacityTop='100%'
          OpacityBottom="50%"
          />

          </ul>
        
          <ul id="matchup2" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[1].rangerTop.characterCard); setDndLink(roundOne[1].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[1].rangerBottom.characterCard); setDndLink(roundOne[1].rangerBottom.ddLink)}}
          AvatarTop={roundOne[1].rangerTop.avatar}
          AvatarBottom={roundOne[1].rangerBottom.avatar}
          TweetId={roundOne[1].tweetId}
          Index={1}
          OpacityTop='100%'
          OpacityBottom="50%"
          />
    
          </ul>
         

         
          <ul id="matchup4" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[3].rangerTop.characterCard); setDndLink(roundOne[3].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[3].rangerBottom.characterCard); setDndLink(roundOne[3].rangerBottom.ddLink)}}
          AvatarTop={roundOne[3].rangerTop.avatar}
          AvatarBottom={roundOne[3].rangerBottom.avatar}
          TweetId={roundOne[3].tweetId}
          Index={3}
          OpacityTop='100%'
          OpacityBottom="50%"
          />
          </ul>

          <ul id="matchup3" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[2].rangerTop.characterCard); setDndLink(roundOne[2].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[2].rangerBottom.characterCard); setDndLink(roundOne[2].rangerBottom.ddLink)}}
          AvatarTop={roundOne[2].rangerTop.avatar}
          AvatarBottom={roundOne[2].rangerBottom.avatar}
          TweetId={roundOne[2].tweetId}
          Index={2}
          OpacityTop='50%'
          OpacityBottom="100%"
          />
  </ul>
  <ul id="matchup6" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[5].rangerTop.characterCard); setDndLink(roundOne[5].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[5].rangerBottom.characterCard); setDndLink(roundOne[5].rangerBottom.ddLink)}}
          AvatarTop={roundOne[5].rangerTop.avatar}
          AvatarBottom={roundOne[5].rangerBottom.avatar}
          TweetId={roundOne[5].tweetId}
          Index={5}
          OpacityTop='100%'
          OpacityBottom="50%"
          /> </ul>
      
          <ul id="matchup5" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[4].rangerTop.characterCard); setDndLink(roundOne[4].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[4].rangerBottom.characterCard); setDndLink(roundOne[4].rangerBottom.ddLink)}}
          AvatarTop={roundOne[4].rangerTop.avatar}
          AvatarBottom={roundOne[4].rangerBottom.avatar}
          TweetId={roundOne[4].tweetId}
          Index={4}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> </ul>
          
         

<ul id="matchup8" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[7].rangerTop.characterCard); setDndLink(roundOne[7].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[7].rangerBottom.characterCard); setDndLink(roundOne[7].rangerBottom.ddLink)}}
          AvatarTop={roundOne[7].rangerTop.avatar}
          AvatarBottom={roundOne[7].rangerBottom.avatar}
          TweetId={roundOne[7].tweetId}
          Index={7}
          OpacityTop='100%'
          OpacityBottom="50%"
          /> </ul>
        
          <ul id="matchup7" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[6].rangerTop.characterCard); setDndLink(roundOne[6].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[6].rangerBottom.characterCard); setDndLink(roundOne[6].rangerBottom.ddLink)}}
          AvatarTop={roundOne[6].rangerTop.avatar}
          AvatarBottom={roundOne[6].rangerBottom.avatar}
          TweetId={roundOne[6].tweetId}
          Index={6}
          OpacityTop='50%'
          OpacityBottom="100%"
          />
          </ul>
     
         
        </div>{" "}
        {/* END ROUND ONE */}
        <div className="round round-two current">
          <div className="round-details">
            Round 2<br />
            <span className="date">March 13</span>
          </div>
          <div>
          <HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[0].rangerTop.characterCard); setDndLink(roundTwo[0].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[0].rangerBottom.characterCard); setDndLink(roundTwo[0].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[0].rangerTop.avatar}
          AvatarBottom={roundTwo[0].rangerBottom.avatar}
          TweetId={roundTwo[0].tweetId}
          ClassTop="team rd2mtch1 rd2 team-top"
          ClassBottom="team rd2mtch2 team-bottom"
          Index={0}
          OpacityTop='100%'
          OpacityBottom="50%"
          />


<HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[1].rangerBottom.characterCard); setDndLink(roundTwo[1].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[1].rangerTop.characterCard); setDndLink(roundTwo[1].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[1].rangerBottom.avatar}
          AvatarBottom={roundTwo[1].rangerTop.avatar}
          TweetId={roundTwo[1].tweetId}
          ClassTop="team rd2mtch3 team-top"
          ClassBottom="team rd2mtch4  team-bottom"
          Index={1}
          OpacityTop='50%'
          OpacityBottom="100%"
          />


<HoverListItemRd2
          OnClickBottom={()=>{handleOpen(roundTwo[2].rangerTop.characterCard); setDndLink(roundTwo[2].rangerTop.ddLink)}}
          OnClickTop={()=>{handleOpen(roundTwo[2].rangerBottom.characterCard); setDndLink(roundTwo[2].rangerBottom.ddLink)}}
          AvatarBottom={roundTwo[2].rangerTop.avatar}
          AvatarTop={roundTwo[2].rangerBottom.avatar}
          TweetId={roundTwo[2].tweetId}
          ClassTop="team rd2mtch5 team-top"
          ClassBottom="team rd2mtch6 team-bottom"
          Index={2}
          OpacityTop='50%'
          OpacityBottom="100%"
          />


<HoverListItemRd2
          OnClickBottom={()=>{handleOpen(roundTwo[3].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickTop={()=>{handleOpen(roundTwo[3].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarBottom={roundTwo[3].rangerTop.avatar}
          AvatarTop={roundTwo[3].rangerBottom.avatar}
          TweetId={roundTwo[3].tweetId}
          ClassTop="team rd2mtch7 team-top"
          ClassBottom="team rd2mtch8 team-bottom"
          Index={3}
          OpacityTop='50%'
          OpacityBottom="100%"
          />

      </div>
     
        </div>{" "}
        {/* END ROUND TWO */}
        <div className="round round-three current">
          <div className="round-details">
            Round 3<br />
            <span className="date">March 20</span>
          </div>
          <HoverListItemRd3
          OnClickTop={()=>{handleOpen(roundThree[0].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundThree[0].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={roundThree[0].rangerTop.avatar}
          AvatarBottom={roundThree[0].rangerBottom.avatar}
          TweetId={roundThree[0].tweetId}
          ClassTop="team team-top rd3mtch1"
          ULClass="matchup rd3-matchup-1"
          ClassBottom="team rd3mtch2 team-bottom"
          Index={0}
          OpacityTop='100%'
          OpacityBottom="50%"
          
          />

        <HoverListItemRd3
          OnClickTop={()=>{handleOpen(roundThree[1].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundThree[1].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={roundThree[1].rangerTop.avatar}
          AvatarBottom={roundThree[1].rangerBottom.avatar}
          TweetId={roundThree[1].tweetId}
          ClassTop="team team-top rd3mtch3"
          ULClass="matchup matchup-2"
          ClassBottom="team rd3mtch4 team-bottom"
          Index={1}
          OpacityTop='50%'
          OpacityBottom="100%"
          />
      
        </div>{" "}
        {/* END ROUND THREE */}
      </div>
      <div className="champion">
        <div className="semis-l">
          <div className="round-details">
            {" "}
            semifinals <br />
            <span className="date">March 27</span>
          </div>
          <HoverListItemRdSemi
          OnClickTop={()=>{handleOpen(semi[0].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(semi[0].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={semi[0].rangerTop.avatar}
          AvatarBottom={semi[0].rangerBottom.avatar}
          TweetId={semi[0].tweetId}
          ClassTop="finals team-top"
          ULClass="matchup championship"
          ClassBottom="finals team-bottom"
          Index={0}
          OpacityTop='50%'
          OpacityBottom="100%"
          
          />
          {/* <ul className="matchup championship" style={{justifyContent:'center'}}>
            <li className="finals team-top">
            <img src={roundThree[0].rangerTop.avatar} height="auto" width="75px"/>

            </li>
            <li className="finals team-bottom" style={{justifyContent:'center'}}>
            <img src={roundThree[1].rangerBottom.avatar} height="auto" width="75px"/>

            </li>
          </ul> */}
        </div>
        <div className="final">
          <i className="fa fa-trophy" />
          <div className="round-details">
           <span style={{fontSize:'16px'}}> championship </span>
            <br />
            <span className="date">March 30</span>
          </div>
       

          <HoverListItemRdSemi
          OnClickTop={()=>{handleOpen(finals[0].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(finals[0].rangerTop.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={finals[0].rangerBottom.avatar}
          AvatarBottom={finals[0].rangerTop.avatar}
          TweetId={finals[0].tweetId}
          ClassTop="finals team-top"
          ULClass="matchup championship"
          ClassBottom="finals team-bottom"
          Index={0}
          OpacityBottom='50%'
          OpacityTop="100%"
          
          />
        </div>
        <div className="semis-r">
          <div className="round-details">
            {" "}
            semifinals <br />
            <span className="date">March 27</span>
          </div>
          <HoverListItemRdSemi
          OnClickTop={()=>{handleOpen(semi[1].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(semi[1].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={semi[1].rangerTop.avatar}
          AvatarBottom={semi[1].rangerBottom.avatar}
          TweetId={semi[1].tweetId}
          ClassTop="finals team-top"
          ULClass="matchup championship"
          ClassBottom="finals team-bottom"
          Index={0}
          OpacityBottom='50%'
          OpacityTop="100%"
          
          />
        </div>
      </div>
      <div className="split split-two">
        <div className="round round-three current">
          <div className="round-details">
            Round 3<br />
            <span className="date">March 20</span>
          </div>

      
          <HoverListItemRd3
          OnClickTop={()=>{handleOpen(roundThree[2].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundThree[2].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={roundThree[2].rangerTop.avatar}
          AvatarBottom={roundThree[2].rangerBottom.avatar}
          TweetId={roundThree[2].tweetId}
          ClassTop="team team-top rd3mtch1"
          ULClass="matchup matchup-1"
          ClassBottom="team rd3mtch2 team-bottom"
          Index={2}
          OpacityTop='100%'
          OpacityBottom="50%"
          />
          <HoverListItemRd3
          OnClickTop={()=>{handleOpen(roundThree[3].rangerTop.characterCard); setDndLink(roundTwo[3].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundThree[3].rangerBottom.characterCard); setDndLink(roundTwo[3].rangerBottom.ddLink)}}
          AvatarTop={roundThree[3].rangerTop.avatar}
          AvatarBottom={roundThree[3].rangerBottom.avatar}
          TweetId={roundThree[3].tweetId}
          ClassTop="team team-top rd3mtch3"
          ULClass="matchup matchup-2"
          ClassBottom="team rd3mtch4 team-bottom"
          Index={1}
          OpacityTop='50%'
          OpacityBottom="100%"
          />
        </div>{" "}
        {/* END ROUND THREE */}
        <div className="round round-two current">
          <div className="round-details">
            Round 2<br />
            <span className="date">March 13</span>
          </div>
          <HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[4].rangerTop.characterCard); setDndLink(roundTwo[4].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[4].rangerBottom.characterCard); setDndLink(roundTwo[4].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[4].rangerTop.avatar}
          AvatarBottom={roundTwo[4].rangerBottom.avatar}
          TweetId={roundTwo[4].tweetId}
          ClassTop="team rd2mtch1 rd2 team-top"
          ClassBottom="team rd2mtch2 team-bottom"
          Index={4}
          OpacityTop='50%'
          OpacityBottom="100%"
          />


<HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[5].rangerTop.characterCard); setDndLink(roundTwo[5].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[5].rangerBottom.characterCard); setDndLink(roundTwo[5].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[5].rangerTop.avatar}
          AvatarBottom={roundTwo[5].rangerBottom.avatar}
          TweetId={roundTwo[5].tweetId}
          ClassTop="team rd2mtch3 team-top"
          ClassBottom="team rd2mtch4  team-bottom"
          Index={5}
          OpacityTop='50%'
          OpacityBottom="100%"
          />


<HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[6].rangerTop.characterCard); setDndLink(roundTwo[6].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[6].rangerBottom.characterCard); setDndLink(roundTwo[6].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[6].rangerTop.avatar}
          AvatarBottom={roundTwo[6].rangerBottom.avatar}
          TweetId={roundTwo[6].tweetId}
          ClassTop="team rd2mtch5 team-top"
          ClassBottom="team rd2mtch6 team-bottom"
          Index={6}
          OpacityTop='100%'
          OpacityBottom="50%"
          />


<HoverListItemRd2
          OnClickTop={()=>{handleOpen(roundTwo[7].rangerTop.characterCard); setDndLink(roundTwo[7].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundTwo[7].rangerBottom.characterCard); setDndLink(roundTwo[7].rangerBottom.ddLink)}}
          AvatarTop={roundTwo[7].rangerTop.avatar}
          AvatarBottom={roundTwo[7].rangerBottom.avatar}
          TweetId={roundTwo[7].tweetId}
          ClassTop="team rd2mtch7 team-top"
          ClassBottom="team rd2mtch8 team-bottom"
          Index={7}
          OpacityTop='100%'
          OpacityBottom="50%"
          />
         
        </div>{" "}
        {/* END ROUND TWO */}
        <div className="round round-one current">
          <div className="round-details">
            Round 1<br />
            <span className="date">March 6</span>
          </div>
          <ul id="matchup9" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[8].rangerTop.characterCard); setDndLink(roundOne[8].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[8].rangerBottom.characterCard); setDndLink(roundOne[8].rangerBottom.ddLink)}}
          AvatarTop={roundOne[8].rangerTop.avatar}
          AvatarBottom={roundOne[8].rangerBottom.avatar}
          TweetId={roundOne[8].tweetId}
          Index={8}
          OpacityTop='100%'
          OpacityBottom="50%"
          />   </ul>
         
          <ul id="matchup10" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[9].rangerTop.characterCard); setDndLink(roundOne[9].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[9].rangerBottom.characterCard); setDndLink(roundOne[9].rangerBottom.ddLink)}}
          AvatarTop={roundOne[9].rangerTop.avatar}
          AvatarBottom={roundOne[9].rangerBottom.avatar}
          TweetId={roundOne[9].tweetId}
          Index={9}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
         
          <ul id="matchup11" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[10].rangerTop.characterCard); setDndLink(roundOne[10].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[10].rangerBottom.characterCard); setDndLink(roundOne[10].rangerBottom.ddLink)}}
          AvatarTop={roundOne[10].rangerTop.avatar}
          AvatarBottom={roundOne[10].rangerBottom.avatar}
          TweetId={roundOne[10].tweetId}
          Index={10}
          OpacityTop='100%'
          OpacityBottom="50%"
          />   </ul>
         
          <ul id="matchup12" className="matchup">
          <HoverListItem 
           OnClickTop={()=>{handleOpen(roundOne[11].rangerTop.characterCard); setDndLink(roundOne[11].rangerTop.ddLink)}}
           OnClickBottom={()=>{handleOpen(roundOne[11].rangerBottom.characterCard); setDndLink(roundOne[11].rangerBottom.ddLink)}}
          AvatarTop={roundOne[11].rangerTop.avatar}
          AvatarBottom={roundOne[11].rangerBottom.avatar}
          TweetId={roundOne[11].tweetId}
          Index={11}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
         
          <ul id="matchup13" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[12].rangerTop.characterCard); setDndLink(roundOne[12].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[12].rangerBottom.characterCard); setDndLink(roundOne[12].rangerBottom.ddLink)}}
          AvatarTop={roundOne[12].rangerTop.avatar}
          AvatarBottom={roundOne[12].rangerBottom.avatar}
          TweetId={roundOne[12].tweetId}
          Index={12}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
         
          <ul id="matchup14" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[13].rangerTop.characterCard); setDndLink(roundOne[13].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[13].rangerBottom.characterCard); setDndLink(roundOne[13].rangerBottom.ddLink)}}
          AvatarTop={roundOne[13].rangerTop.avatar}
          AvatarBottom={roundOne[13].rangerBottom.avatar}
          TweetId={roundOne[13].tweetId}
          Index={13}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
         
          <ul id="matchup15" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[14].rangerTop.characterCard); setDndLink(roundOne[14].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[14].rangerBottom.characterCard); setDndLink(roundOne[14].rangerBottom.ddLink)}}
          AvatarTop={roundOne[14].rangerTop.avatar}
          AvatarBottom={roundOne[14].rangerBottom.avatar}
          TweetId={roundOne[14].tweetId}
          Index={14}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
         
          <ul id="matchup16" className="matchup">
          <HoverListItem 
          OnClickTop={()=>{handleOpen(roundOne[15].rangerTop.characterCard); setDndLink(roundOne[15].rangerTop.ddLink)}}
          OnClickBottom={()=>{handleOpen(roundOne[15].rangerBottom.characterCard); setDndLink(roundOne[15].rangerBottom.ddLink)}}
          AvatarTop={roundOne[15].rangerTop.avatar}
          AvatarBottom={roundOne[15].rangerBottom.avatar}
          TweetId={roundOne[15].tweetId}
          Index={15}
          OpacityTop='50%'
          OpacityBottom="100%"
          /> 
          </ul>
        </div>{" "}
        {/* END ROUND ONE */}
      </div>
    </div>
  </section>
  <div className="footer-bg" style={{height:'200px' }}>
  <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
    
    <Copyright sx={{ pt: 4 }} />
  </Container>
</div>
  <section style={{backgroundColor:'black'}} className="share">
 
   
  </section>
</>

        </div>
    )
}
